import React, {FunctionComponent} from "react";
import {Box, makeStyles, Paper, useMediaQuery, useTheme} from "@material-ui/core";
import UnderlinedTextButton from "../../../../commonComponents/UnderlinedTextButton";
import Text from "../../../../commonComponents/Text";
import {Step} from "../../../WizardMap";
import {pickUpTimeToStringShort} from "../contact/SelectOptions";
import {ContactState} from "../../../state/contactSlice";
import moment from "moment";


const useStyles = makeStyles(theme => ({
    container: {
        width: 554,
        paddingLeft: 5,
        [theme.breakpoints.down("xs")]: {
            width: 266,
            paddingLeft: 0
        },
        display: "flex",
        flexWrap: "wrap"
    },
    contentContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        borderRadius: 2,
        padding: 10,
        width: 250,
        minHeight: 107,
        [theme.breakpoints.down("xs")]: {
            marginBottom: 20
        }
    },
    captionContainer: {
        width: 97
    },
    disposalItemContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        borderRadius: 2,
        padding: 10,
        width: 249,
        minHeight: 107,
        [theme.breakpoints.down("xs")]: {
            marginBottom: 10
        }
    }
}));

const emailToLineBreakingEmail = (email: string) => {
    const separatedMail: string[] = email.split("@");
    return (
        <Box display={"flex"} flexWrap={"wrap"}>
            <Text value={`${separatedMail[0]}@`} size={12}/>
            <Text value={separatedMail[1]} size={12}/>
        </Box>
    );
};


type ContactAndPickUpSummaryProps = {
    contact: ContactState,
    jumpTo: (step: Step) => void;
};

const ContactAndPickUpSummary: FunctionComponent<ContactAndPickUpSummaryProps> = (
    {contact, jumpTo}) => {

    const {pickUp} = contact;

    const classes = useStyles();

    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down("xs"));

    const onEditContactData = () => {
        if (isXs) {
            jumpTo(Step.CONTACT_INFO_MOBILE_1);
        } else {
            jumpTo(Step.CONTACT_INFO);
        }
    };

    const contactDataFullName = contact.address.name.concat(" ").concat(contact.address.lastName);

    return (
        <Box
            className={classes.container}
            style={{
                justifyContent: contact.pickUp ? "space-around" : "center",
                paddingLeft: !contact.pickUp && !isXs ? 11 : 0
            }}
        >
            <Box>
                <Paper className={classes.disposalItemContainer}>
                    <Box display={"flex"} flexDirection={"row"}>
                        <Box className={classes.captionContainer}>
                            <Text value={"Kontakt:"} size={12}/>
                        </Box>
                        <Box>
                            <Text
                                value={contactDataFullName}
                                size={12}
                            />
                            <Text value={contact.address.street} size={12}/>
                            <Text
                                value={String(contact.address.postalCode).concat(" ").concat(contact.address.city)}
                                size={12}/>
                            <Text value={contact.phone} size={12}/>
                            {emailToLineBreakingEmail(contact.email)}
                        </Box>

                    </Box>
                    <UnderlinedTextButton
                        text={"Bearbeiten"}
                        onClick={onEditContactData}
                        fontSize={13}
                    />
                </Paper>
            </Box>
            {pickUp &&
            <Box>
                <Paper className={classes.disposalItemContainer}>
                    <Box display={"flex"} flexDirection={"row"}>
                        <Box className={classes.captionContainer}>
                            <Text value={"Abholadresse:"} size={12}/>
                        </Box>
                        <Box>
                            <Text
                                value={pickUp.address
                                    ? pickUp.address.name.concat(" ".concat(pickUp.address.lastName))
                                    : contactDataFullName}
                                size={12}
                            />
                            <Text
                                value={pickUp.address ? pickUp.address.street : contact.address.street}
                                size={12}
                            />
                            <Text
                                value={pickUp.address
                                    ? pickUp.address.postalCode.concat(" ").concat(pickUp.address.city)
                                    : contact.address.postalCode.concat(" ").concat(contact.address.city)}
                                size={12}
                            />
                        </Box>
                    </Box>

                    <Box display={"flex"} flexDirection={"row"}>
                        <Box className={classes.captionContainer}>
                            <Text value={"Abholtermin:"} size={12}/>
                        </Box>
                        <Box>
                            <Text
                                value={`${moment(pickUp.date).format()} | ${pickUpTimeToStringShort(Number(pickUp.timespan))}`}
                                size={12}
                            />
                        </Box>
                    </Box>

                    <UnderlinedTextButton
                        text={"Bearbeiten"}
                        onClick={() => jumpTo(Step.SHIPPING_INFO)}
                        fontSize={13}
                    />
                </Paper>
            </Box>}
        </Box>
    );
};

export default ContactAndPickUpSummary;
